<template>
  <v-app :class="classModal">
    <router-view />
  </v-app>
</template>

<script lang="ts">
import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { ModalMixin } from "../mixins/ModalMixin";
import { State } from "vuex-class";
@Component({
  watch: {
    $route: {
      handler: function (): void {
        (this as any).updateTitle();
      },
      immediate: true,
    },
    "$i18n.locale": {
      handler: function (): void {
        (this as any).updateTitle();
      },
    },
  },
})
export default class App extends mixins(ModalMixin) {
  @State("classModal") classModal: any;

  updateTitle(): void {
    const displayName = this.$route?.meta?.displayName;
    document.title = displayName
      ? String(this.$i18n.t(displayName))
      : "Exclusive Lounge";
  }
}
</script>

<style></style>
